import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./Login.css";
import {BASE_URL} from "./Constants";
import { useAuth } from "./context/AuthContext"; // add this


const Login = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth(); // add this

  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");

  // handle input changes
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  
  const handleLogin = async () => {
    if (!formData.email || !formData.password) {
      setMessage("Enter email and password")
      return;
    }

    try {
      const encodedPassword = btoa(formData.password); // base64 encode
      const res = await fetch(`${BASE_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, password: encodedPassword }),
        credentials: "include"  
      });
      const data = await res.json();
      if (!res.ok || data.error) throw new Error(data.error || "Login failed");

      setUser(data);  // update AuthContext immediately

      setMessage("Login successful!")
      navigate("/ItemsPage", { replace: true }); // pass user info
    } catch (err) {
      setMessage(err.message || "Login error")
    }
  };


  return (
    <div className="checkout-login-container">
      <h2 className="checkout-title">Login</h2>

      <div className="checkout-login-box">
        {/* Left side - logo */}
        <div className="login-left">
          <p>Welcome! Please login to continue.</p>
          <img
            src="/assets/logo_1.png"
            alt="Company Logo"
            className="company-logo"
          />
        </div>

        {/* Right side - login form */}
        <div className="login-right">
          <h3>Login</h3>
          <div className="login-form">
            <input
              type="text"
              name="email"
              placeholder="📧 Enter email"
              value={formData.email}
              onChange={handleInputChange}
            />

            <div className="password-container">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="🔒 Enter password"
                value={formData.password}
                onChange={handleInputChange}
              />
              <span
                className="eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            {message && <p className="msg">{message}</p>}

            <button className="login-btn" onClick={handleLogin}>
              Log In
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;

